<template>
  <div>
    <!-- Bパターン: 新しいFV -->
    <top-header-img-banner v-if="isBPattern" />
    <!-- ABテストが無効の場合は既存のFVを表示 -->
    <top-header-carousel-banner v-else :banners="props.banners" />
    <week-day-event />
    <date-search-button class="topPageHeader-dateButton" />
  </div>
</template>

<script setup lang="ts">
import type { TopBanner } from '@/types/TopBanner'
import useABTestV2 from '@/utils/abtest/useABTestV2'
import { TOP_FV_V4_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'
import { sendTopPageViewEvent } from '@/utils/abtest/topFvGAEvent'

const props = defineProps<{
  banners: TopBanner[]
}>()

// ABテストの判定
const { isBPattern } = useABTestV2(TOP_FV_V4_AB_TEST_CONFIG)

const TopHeaderCarouselBanner = defineAsyncComponent(() => import('@/components/top/TopHeaderCarouselBanner.vue'))
const TopHeaderImgBanner = defineAsyncComponent(() => import('@/components/top/TopHeaderImgBanner.vue'))
const DateSearchButton = defineAsyncComponent(() => import('@/components/top/DateSearchButton.vue'))
const WeekDayEvent = defineAsyncComponent(() => import('@/components/top/WeekDayEvent.vue'))

// mountedフックでGAイベント送信
onMounted(() => {
  sendTopPageViewEvent()
})
</script>

<style lang="scss" scoped></style>
